import { Chart as ChartJS, registerables } from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'

import { defineNuxtPlugin } from '#imports'

ChartJS.register(...registerables, ChartDataLabels)
export default defineNuxtPlugin(() => {})
